import React, { memo, useEffect, useLayoutEffect } from 'react';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import {
  makeSelectDaysFilterDataArray,
  makeSelectLocationFilterDataArray,
  makeSelectDegreeFilterDataArray,
  makeSelectNiveauFilterDataArray,
  makeSelectEventTypeFilterDataArray,
  makeSelectStructureFilterComplex,
  makeSelectStructureFilterContent,
  makeSelectTimeFilterDataArray, makeSelectSpecialFilterDataArray,
} from '../selectors';
import { setFilterActive, setStructureFilterId } from '../actions';
import { loadCourses } from '../../App/actions';
import StructurePreFilter from '../SearchFilters/PreFilter';
import LocationPreFilter from '../SearchLocations/PreFilter';
import DegreePreFilter from '../SearchDegree/PreFilter';
import NiveauPreFilter from '../SearchNiveau/PreFilter';
import EventTypePreFilter from '../SearchEventType/PreFilter';
import TimePreFilter from '../SearchTime/PreFilter';
import SpecialPreFilter from '../SearchSpecial/PreFilter';
import DaysPreFilter from '../SearchDays/PreFilter';
import { FILTERS, isFilterActive } from '../../../utils/site';

export const StructureFilter = ({
  onLoadCourses,
  onSetStructureFilterId,
  structureFilterComplex,
  locationFilterDataArray,
  degreeFilterDataArray,
  niveauFilterDataArray,
  eventTypeFilterDataArray,
  daysFilterDataArray,
  timeFilterDataArray,
  specialFilterDataArray,
  onSetFilterActive,
}) => {
  useLayoutEffect(() => {
    onSetStructureFilterId(structureFilterComplex[0] ?? '');
    onLoadCourses();
  }, [structureFilterComplex]);

  useEffect(() => {
    let filterLength = 0;
    filterLength += structureFilterComplex.length;
    filterLength += locationFilterDataArray.length;
    filterLength += degreeFilterDataArray.length;
    filterLength += niveauFilterDataArray.length;
    filterLength += eventTypeFilterDataArray.length;
    filterLength += daysFilterDataArray.length;
    filterLength += timeFilterDataArray.length;
    filterLength += specialFilterDataArray.length;
    onSetFilterActive(filterLength);
  }, [structureFilterComplex, locationFilterDataArray, daysFilterDataArray, timeFilterDataArray, specialFilterDataArray, degreeFilterDataArray, niveauFilterDataArray, eventTypeFilterDataArray]);

  /**
   * Main return function.
   */
  return (
    <>
      {/* Nur aktive Filter werten URL-Parameter aus — sonst würde ein
          ausgeblendeter Filter unsichtbar weiterfiltern. */}
      {isFilterActive(FILTERS.STRUCTURE) && <StructurePreFilter />}
      {isFilterActive(FILTERS.LOCATION) && <LocationPreFilter />}
      {isFilterActive(FILTERS.DEGREE) && <DegreePreFilter />}
      {isFilterActive(FILTERS.NIVEAU) && <NiveauPreFilter />}
      {isFilterActive(FILTERS.EVENT_TYPE) && <EventTypePreFilter />}
      {isFilterActive(FILTERS.TIME) && <TimePreFilter />}
      {isFilterActive(FILTERS.SPECIAL) && <SpecialPreFilter />}
      {isFilterActive(FILTERS.DAYS) && <DaysPreFilter />}
    </>
  );
};

StructureFilter.propTypes = {
  onLoadCourses: PropTypes.func,
  onSetStructureFilterId: PropTypes.func,
  structureFilterComplex: PropTypes.array,
  locationFilterDataArray: PropTypes.array,
  degreeFilterDataArray: PropTypes.array,
  niveauFilterDataArray: PropTypes.array,
  eventTypeFilterDataArray: PropTypes.array,
  daysFilterDataArray: PropTypes.array,
  timeFilterDataArray: PropTypes.array,
  specialFilterDataArray: PropTypes.array,
  onSetFilterActive: PropTypes.func,
};

StructureFilter.defaultProps = {
  onLoadCourses: () => {},
  onSetStructureFilterId: () => {},
  structureFilterComplex: [],
  locationFilterDataArray: [],
  degreeFilterDataArray: [],
  niveauFilterDataArray: [],
  eventTypeFilterDataArray: [],
  daysFilterDataArray: [],
  timeFilterDataArray: [],
  specialFilterDataArray: [],
  onSetFilterActive: () => {},
};

const mapStateToProps = createStructuredSelector({
  structureItems: makeSelectStructureFilterContent(),
  structureFilterComplex: makeSelectStructureFilterComplex(),
  locationFilterDataArray: makeSelectLocationFilterDataArray(),
  degreeFilterDataArray: makeSelectDegreeFilterDataArray(),
  niveauFilterDataArray: makeSelectNiveauFilterDataArray(),
  eventTypeFilterDataArray: makeSelectEventTypeFilterDataArray(),
  daysFilterDataArray: makeSelectDaysFilterDataArray(),
  timeFilterDataArray: makeSelectTimeFilterDataArray(),
  specialFilterDataArray: makeSelectSpecialFilterDataArray(),
});

export function mapDispatchToProps(dispatch) {
  return {
    onLoadCourses: () => dispatch(loadCourses()),
    onSetStructureFilterId: (value) => dispatch(setStructureFilterId(value)),
    onSetFilterActive: (value) => dispatch(setFilterActive(value)),
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(StructureFilter);
